.bg {
  --color-1: theme("colors.purple.500");
  --color-2: theme("colors.fuchsia.400");
  --color-3: theme("colors.rose.400");

  @apply origin-top;
  background-image: linear-gradient(
    to right,
    var(--color-1),
    var(--color-2),
    var(--color-3),
    var(--color-2),
    var(--color-1),
    var(--color-2),
    var(--color-3)
  );
  background-size: 300% 100%;
  animation:
    bg-gradient 5s linear infinite,
    theme("animationTimingFunction.in-out");
}

@keyframes bg-gradient {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: 100%;
  }
}

@keyframes bg-bounce {
  0%,
  100% {
    transform: scaleY(1);
  }
  40%,
  60% {
    transform: scaleY(1.5);
  }
  80% {
    transform: scaleY(0.95);
  }
}

.content {
  animation: content-translate 1s theme("animationTimingFunction.in-out");
}

@keyframes content-translate {
  0%,
  100% {
    transform: translateY(0);
  }
  40%,
  60% {
    transform: translateY(calc(var(--height) * 0.5 / 2));
  }
  80% {
    transform: translateY(calc(var(--height) * 0.05 / 2 * -1));
  }
}

@keyframes icon-pop {
  0%,
  100% {
    transform: scale(1);
  }
  40%,
  60% {
    transform: scale(1.32);
  }
  80% {
    transform: scale(0.85);
  }
}

@keyframes icon-shake {
  0% {
    transform: rotate(0);
  }
  20% {
    transform: rotate(-10deg);
  }
  40% {
    transform: rotate(10deg);
  }
  60% {
    transform: rotate(0);
  }
}

@keyframes icon-shadow {
  0%,
  100% {
    filter: drop-shadow(0 0 0 rgb(105 28 79 / 0.5));
  }
  40%,
  60% {
    filter: drop-shadow(0 4px 12px rgb(105 28 79 / 1));
  }
}
